<template>
  <v-card class="mb-2">
    <v-card-text>
      <h1 class="host-dashboard-title">My Locations</h1>
      <!-- MOBILE -->
      <div class="hidden-md-and-up">
        <v-card raised v-for="location in getMyLocations" :key="location.uuid">
          <v-img
            :src="location.primary_image.image"
            aspect-ratio="2.75"
          ></v-img>
          <v-card-text>
            {{ location.name }} <br>
            <p>{{getAddress(location)}}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn :to="{ name: 'host_dashboard_location_details', params: { slug: location.slug }}">Manage</v-btn>
            <v-btn class="success" style="color: white!important;" :to="{ name: 'location', params: { slug: location.slug }}">View</v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <!-- DESKTOP -->
      <div class="hidden-sm-and-down">
        <v-data-table
          :headers="headers"
          :items="getMyLocations"
          hide-actions
          class="elevation-1"
          item-key="title"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="pa-2"><img :src="props.item.primary_image.image" height="50"></td>
              <td class="host-dashboard-tile-title">{{ props.item.name }}</td>
              <td class="host-dashboard-tile-sub-title hidden-xs-only">{{ getAddress(props.item) }}</td>
              <td>{{props.item.max_attendees}}</td>
              <td>
                <v-btn class="btn-blue" :to="{ name: 'host_dashboard_location_details', params: { slug: props.item.slug }}">Manage</v-btn>
                <v-btn class="success" style="color: white!important;" :to="{ name: 'location', params: { slug: props.item.slug }}">View</v-btn>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(<br>
              <v-btn @click="newLocation">Create a new location!</v-btn>
            </v-alert>
          </template>
        </v-data-table>
      </div>
      <!-- <v-list two-line class="pa-0">
        <v-divider>
        </v-divider>
        <div v-for="location in getMyLocations">
          <v-list-tile avatar v-bind:key="location.title" :to="{ name: 'host_dashboard_location_details', params: { slug: location.slug }}">
            <img :src="location.primary_image.image" class="image-thumb pa-2">
            <v-list-tile-content>
              <v-layout row wrap justify-center align-center style="width: 100%">
                <v-flex xs12 sm12>
                  <p class="host-dashboard-tile-title">{{location.name}}</p>
                  <p class="host-dashboard-tile-sub-title" v-if="location">{{getAddress(location)}}</p>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider>
          </v-divider>
        </div>
      </v-list> -->
    </v-card-text>
    <v-card-actions>
      <v-btn class="btn-blue" @click="newLocation">New Location</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getAddressStringFromObject} from '~/utils/helper'
import { fetchAllLocations } from '~/store/api/event_location_api'
export default {
  name: 'host_dashboard_upcoming_events',
  data () {
    return {
      headers: [
        {
          text: 'Image',
          sortable: false,
          value: 'image'
        },
        { text: 'Name', sortable: false, value: 'title' },
        { text: 'Address', sortable: false, value: 'address' },
        { text: 'Attendee Capacity', sortable: false, value: 'attendees' },
        { text: 'Actions', sortable: false, value: 'actions' }
      ]
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter')
		fetchAllLocations().then((response) => {
      console.log(response.data)
			next(vm => {
				vm.setLocations(response.data)
			})
		}).catch((error) => {
			console.error(error)
			next()
		})
  },
  methods: {
    ...mapActions([
      'setAllLocations'
    ]),
    setLocations(locations) {
      this.setAllLocations(locations)
    },
    editLocation () {
      alert('editing locations is not setup')
    },
    newLocation() {
			this.addLocationResetState()
			this.$router.push('/host/add/location')
		},
    getAddress(location) {
			return getAddressStringFromObject(location)
		}
  },
  computed: {
    ...mapGetters([
      'getMyLocations',
    ])
  }
}
</script>

<style>

</style>
